export default __webpack_public_path__ + "static/media/t20.812e890b.jpg";